// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-details .vue-map-container{height:432px!important}@media (max-width:640px){.location-details .vue-map-container{height:100%!important}}.location-menu-slider{background:none!important}.location-menu-slider>div{padding:0;margin-top:-30px;margin-bottom:120px}@media (max-width:640px){.location-menu-slider>div{margin-bottom:60px}}", ""]);
// Exports
module.exports = exports;
